module.exports = __webpack_public_path__ + "src/components/ViewListing/ListingIntro/slumber.svg?a587772d";


//////////////////
// WEBPACK FOOTER
// ./src/components/ViewListing/ListingIntro/slumber.svg
// module id = 3125
// module chunks = 8